import { faShapes } from '@fortawesome/pro-light-svg-icons';
import { Action, ButtonGroup, Page } from 'corso-admin-ui';
import { useCallback, useState } from 'react';
import { useStoreId } from '~/providers/StoreUserProvider';
import AutomationsAsFlow from './AutomationsAsFlow';
import AutomationsAsList from './AutomationsAsList';
import AutomationTemplates from './AutomationTemplates';
import { ShowAs, useAutomationsShowAs } from './hooks/useAutomationsShowAs';

export default function AutomationsPage() {
  const storeId = useStoreId();
  const [showAs, setShowAs] = useAutomationsShowAs();
  const [showTemplates, setShowTemplates] = useState(false);

  const setShow = useCallback(
    (show: ShowAs | 'templates') => {
      if (show === 'templates') {
        setShowTemplates(true);
      } else {
        setShowTemplates(false);
        setShowAs(show);
      }
    },
    [setShowAs],
  );

  return (
    <Page
      title="Automations"
      overrideActions={
        <ButtonGroup>
          <Action
            onClick={() => setShow(ShowAs.Flow)}
            pressed={!showTemplates && showAs === ShowAs.Flow}
            icon="branch"
            accessibilityLabel="Show Flow"
          >
            Flow
          </Action>
          <Action
            onClick={() => setShow(ShowAs.List)}
            pressed={!showTemplates && showAs === ShowAs.List}
            icon="rule"
            accessibilityLabel="Show List"
          >
            List
          </Action>
          <Action
            onClick={() => setShow('templates')}
            pressed={showTemplates}
            icon={faShapes}
            accessibilityLabel="Show Template"
          >
            Templates
          </Action>
        </ButtonGroup>
      }
      primaryAction={{
        content: 'Create',
        to: {
          pathname: 'create',
          search: new URLSearchParams({
            returnTo: `/${storeId}/settings/automations`,
          }).toString(),
        },
      }}
    >
      <div className="flex flex-col gap-4">
        {showTemplates ? (
          <AutomationTemplates />
        ) : (
          <>
            {showAs === ShowAs.List && <AutomationsAsList />}
            {showAs === ShowAs.Flow && <AutomationsAsFlow />}
          </>
        )}
      </div>
    </Page>
  );
}
